import React, { Fragment, useEffect, useState } from 'react'
import ErrorBoundary from '../../ErrorBoundry';
import { Col, Container, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import AdvanceSearch from '../../CommonComponents/AdvanceSearch';
import TelerikDataTable from '../../CommonComponents/TelerikDataTable';
import { useAuth } from "oidc-react";
import { filterAllowedColumn } from "../../_helper/helper";
import visibleColumns from './supervisorsVisibleColumns';
import CustomButton from '../../CommonComponents/FormComponents/Button';
import { loadingPanel } from '../../CommonComponents/CommonFunction';
import { setAdditionalWhere } from '../../store/Common/actions';
import { AssignEmployeeToSupervisor } from '../../store/PayrollEmployee/slice';
import axios from 'axios';

const ASSIGN_EMPLOYEE_TO_SUPERVISOR = 'Payroll/AssignEmployeeToSupervisor'


const SupervisorTable = (props) => {
    const { selectedEmployees = [], supervisorId = 0, handleClose, isAllSelectedEmployees, employeeAdditionalWhere = '', employeeTableName,setResponsed} = props;
    const dispatch = useDispatch();

    const tableName = "vw_GetallSupervisior";

    const {
        columns,
        loadingSearch,
        searchResultsV2,
    } = useSelector((state) => {
        return state.advanceSearchv2Reducer;
    });
    const {
        filter: storeFilter,
        additionalWhere: storeAdditionalWhere,
        pageSize: storePageSize,
    } = useSelector((state) => {
        return state.CommonReducer;
    });
    const { results, rowCount } = searchResultsV2[tableName] == undefined ? { results: [], rowCount: 0 } : searchResultsV2[tableName];
    // const {
    //     loadingCertification
    // } = useSelector((state) => {
    //     return state.UpdateHoldReducer;
    // });

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(storePageSize[tableName] || 100);
    const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
    const [sortData, setSortData] = useState([]);
    const { userData, userData: { profile: { role } } = {} } = useAuth();
    const [searchParams, setSearchParams] = useState([]);
    const [localAdditionalWhere, setLocalAdditionalWhere] = useState(``);
    const [sortedColumns, setSortedColumns] = useState([]);
    const [deleteData, setDeleteData] = useState(null);
    const [selectedSupervisors, setSelectedSupervisors] = useState([]);
    const [isAllSupervisorsSelected, setIsAllSupervisorsSelected] = useState(false);

    useEffect(() => {
        if (columns && visibleColumns.length > 0 && columns.length > 0) {
            const clms = visibleColumns.map((d) => d.field.toLowerCase());
            const data = columns
                .filter((p) => clms.indexOf(p.column_name.toLowerCase()) < 0)
                .map((p) => {
                    return {
                        field: p.column_name,
                        show: false,
                        locked: false,
                        width: p.column_title.length * 13,
                        title: p.column_title,
                        filter: "text",
                    };
                });
            setSortedColumns(
                filterAllowedColumn(userData, visibleColumns.concat(data)),
                "id"
            );
        }
    }, [columns]);


    useEffect(() => {
        dispatch(setAdditionalWhere({ [tableName]: `SupervisorEmployeeId != '${supervisorId}'` }));
    }, [supervisorId]);

    const handlePageChange = (event) => {
        setPage(event.page.skip / event.page.take + 1);
        setPageSize(event.page.take);
    };
    const handleSortChange = (sort) => {
        setSortData(sort);
        setPage(1);
        setPageSize(100);
    };
    const handleFilterChange = (data) => {
        dispatch(setAdditionalWhere({ [tableName]: `${data ? data + ' AND' : ''} SupervisorEmployeeId != '${supervisorId}'` }))
        setPage(1);
        setPageSize(100);
    };
    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPage(1);
    };

    const handleAssignSupervisors = () => {
        if (window.confirm(`Are you sure want to assign to ${isAllSupervisorsSelected ? 'all supervisors' : 'selected supervisors(s)'}?`)) {
            const payload = {
                "supervisorIds": isAllSupervisorsSelected ? [] : selectedSupervisors,
                "employeeIds": isAllSelectedEmployees ? [] : selectedEmployees,
                "CurrentSupervisorId": supervisorId,
                "SupervisorSearchParam": isAllSupervisorsSelected ? {
                    "tableName": tableName,
                    "searchParams": "[]",
                    "columns": "*",
                    "additionalWhere": storeAdditionalWhere[tableName],
                    "qID": 0,
                    "location": "global",
                    "id": tableName
                } : null,
                "EmployeeSearchParam": isAllSelectedEmployees ? {
                    "tableName": employeeTableName,
                    "searchParams": "[]",
                    "columns": "*",
                    "additionalWhere": employeeAdditionalWhere,
                    "qID": 0,
                    "location": "global",
                    "id": employeeTableName
                } : null,
            }
            AssignEmployeeToSupervisor(payload).then(response => {
                if (response.payload?.response?.status === 200) {
                    handleClose()
                }
            })
        }
    }

    const AssignEmployeeToSupervisor = (async (payload) => {
        try {
            let response = await axios.post(`${process.env.REACT_APP_API_URL_PR}${ASSIGN_EMPLOYEE_TO_SUPERVISOR}` ,payload,{
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
                },
              });
              console.log("DSadaadsdda", response);
               handleClose()
              setResponsed(response?.data)
             
        } catch (error) {
           
           console.log("erorr", error);
          
        }
      }
      );

    return (
        <ErrorBoundary>
            <Fragment>
                {/* {loadingCertification && loadingPanel()} */}
                <Container fluid style={{ overflow: "auto" }}>
                    <div className="mb-2">
                        <CustomButton
                            text="Assign to Supervisor"
                            onClick={handleAssignSupervisors}
                            style={{ fontSize: "14px" }}
                            disabled={!selectedSupervisors?.length}
                        />
                    </div>
                    <div style={{ position: "sticky", top: 0, zIndex: 1 }}>

                        {tableName == "" ? null : (
                            <Row>
                                <Col sm="12" className="page-content">
                                    <AdvanceSearch
                                        id={tableName}
                                        gridId={tableName}
                                        location="global"
                                        columnLocation="global"
                                        columnList={"*"}
                                        columnRefernces={[]}
                                        tableName={tableName}
                                        forceParams={searchParams}
                                        searchParams={searchParams}
                                        additionalWhere={localAdditionalWhere}
                                        expanded={true}
                                        sortData={sortData}
                                        pageNumber={page}
                                        pageSize={pageSize}
                                        chooseFilterMethod={chooseFilterMethod}
                                        deleteData={deleteData}
                                    />
                                    <div>
                                        {sortedColumns.length > 0 && results && (
                                            <TelerikDataTable
                                                id={tableName}
                                                gridId={tableName}
                                                pageSize={pageSize}
                                                totalCount={rowCount}
                                                skip={(page - 1) * pageSize}
                                                take={pageSize}
                                                data={results || []}
                                                sortData={sortData}
                                                onFilterChange={handleFilterChange}
                                                onSortChange={handleSortChange}
                                                onPageChange={handlePageChange}
                                                onPageSizeChange={handlePageSizeChange}
                                                selectedColumns={sortedColumns}
                                                setSortedColumns={setSortedColumns}
                                                loading={loadingSearch}
                                                actions={[]}
                                                setChooseFilterMethod={setChooseFilterMethod}
                                                chooseFilterMethod={chooseFilterMethod}
                                                checkboxAction={true}
                                                handleSelectCheckbox={setSelectedSupervisors}
                                                checkboxKey={"SupervisorEmployeeID"}
                                                handleSelectAll={setIsAllSupervisorsSelected}
                                            />
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        )}

                    </div>
                </Container>
            </Fragment>
        </ErrorBoundary>
    )
}

export default SupervisorTable;